import { useEffect, useState } from 'react';
import { Smartphone, Download } from 'lucide-react';

const DownloadRedirect = () => {
  const [redirecting, setRedirecting] = useState(true);
  const [platform, setPlatform] = useState('');

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
    // iOS detection
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      setPlatform('iOS');
      setTimeout(() => {
        window.location.href = 'https://apps.apple.com/hr/app/albmove/id6759310357';
      }, 1500);
      return;
    }
    
    // Android detection
    if (/android/i.test(userAgent)) {
      setPlatform('Android');
      setTimeout(() => {
        window.location.href = 'https://play.google.com/store/apps/details?id=com.albmove.client&hl=sq';
      }, 1500);
      return;
    }
    
    // Desktop - show options
    setRedirecting(false);
  }, []);

  if (redirecting && platform) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-purple-600 to-indigo-700 flex items-center justify-center p-4">
        <div className="text-center text-white">
          <div className="w-20 h-20 rounded-full bg-white/10 backdrop-blur flex items-center justify-center mx-auto mb-6">
            <Download className="w-10 h-10 text-white animate-bounce" />
          </div>
          <h1 className="text-3xl font-bold mb-4">Duke ju ridrejtuar...</h1>
          <p className="text-purple-200">
            Po hapim {platform === 'iOS' ? 'App Store' : 'Google Play'} për të shkarkuar AlbMove
          </p>
          <div className="mt-8">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin mx-auto" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-600 to-indigo-700 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="text-center text-white mb-8">
          <div className="w-20 h-20 rounded-full bg-white/10 backdrop-blur flex items-center justify-center mx-auto mb-6">
            <Smartphone className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-3xl font-bold mb-4">Shkarkoni AlbMove</h1>
          <p className="text-purple-200">
            Zgjidhni platformën tuaj për të shkarkuar aplikacionin
          </p>
        </div>
        
        <div className="space-y-4">
          <a 
            href="https://apps.apple.com/hr/app/albmove/id6759310357"
            className="flex items-center gap-4 bg-black text-white rounded-2xl p-5 font-medium hover:bg-gray-900 transition-all hover:scale-105 w-full"
          >
            <svg className="w-12 h-12" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
            </svg>
            <div className="text-left flex-1">
              <p className="text-sm opacity-70">Shkarko për</p>
              <p className="text-xl font-semibold">iPhone / iPad</p>
            </div>
            <Download className="w-6 h-6" />
          </a>
          
          <a 
            href="https://play.google.com/store/apps/details?id=com.albmove.client&hl=sq"
            className="flex items-center gap-4 bg-black text-white rounded-2xl p-5 font-medium hover:bg-gray-900 transition-all hover:scale-105 w-full"
          >
            <svg className="w-12 h-12" viewBox="0 0 24 24" fill="currentColor">
              <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
            </svg>
            <div className="text-left flex-1">
              <p className="text-sm opacity-70">Shkarko për</p>
              <p className="text-xl font-semibold">Android</p>
            </div>
            <Download className="w-6 h-6" />
          </a>
        </div>
        
        <p className="text-center text-purple-200 text-sm mt-8">
          Aplikacioni është falas dhe i disponueshëm për të gjithë
        </p>
      </div>
    </div>
  );
};

export default DownloadRedirect;
